import React, { useEffect } from "react";
import "./NotFound.css";

function NotFound() {
  useEffect(() => {
    const originalColor = document
      .querySelector("meta[name='theme-color']")
      .getAttribute("content");
    const metaThemeColor = document.querySelector("meta[name='theme-color']");
    if (metaThemeColor) {
      metaThemeColor.setAttribute("content", "#131921");
    }

    return () => {
      if (metaThemeColor) {
        metaThemeColor.setAttribute("content", originalColor);
      }
    };
  }, []);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-center not_found">
        <div className="text-center">
          <h1 className="display-1 fw-bold">404</h1>
          <p className="fs-3">
            {" "}
            <span className="text-danger">😖Oops!</span> Page not found.
          </p>
          <p className="lead">The page you’re looking for doesn’t exist.</p>
          <a href="/" className="btn btn-success">
            Go Home
          </a>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
